import mergeSmimeOnlyProperties from '../actions/mergeSmimeOnlyProperties';
import SmimeMessage from 'owa-smime-adapter/lib/store/schema/SmimeMessage';
import parseNameFromFullyQualifiedDomainName from '../utils/parseNameFromFullyQualifiedDomainName';
import { ClientItem } from 'owa-mail-store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import ItemId from 'owa-service/lib/contract/ItemId';
import { trace } from 'owa-trace';
import { mutator } from 'satcheljs';

/**
 * Updates S/MIME properties inside client item
 */
export default mutator(mergeSmimeOnlyProperties, actionMessage => {
    const itemId: ItemId = actionMessage.itemId;
    const item: ClientItem = itemId?.Id && getMailStore().items.get(itemId.Id);
    const smimeMessage: SmimeMessage = actionMessage.smimeMessage;

    if (item) {
        item.Smime = {
            SmimeType: smimeMessage.SmimeType,
            Signature: smimeMessage.SmimeSignature && {
                ...smimeMessage.SmimeSignature,
                CertIssuedTo: parseNameFromFullyQualifiedDomainName(
                    smimeMessage.SmimeSignature.CertIssuedTo
                ),
                CertIssuedBy: parseNameFromFullyQualifiedDomainName(
                    smimeMessage.SmimeSignature.CertIssuedBy
                ),
            },
            isDecoded: true,
            RawDate: smimeMessage.RawDate,
        };
    } else {
        trace.error('SmimeTraceError: Item being merged should exist in the store');
    }
});
